import { createFileRoute } from "@tanstack/react-router";
import { UserTable } from "@/components/admin/user-table";

export const Route = createFileRoute("/_auth/app/admin/users")({
  component: UsersPage,
});

function UsersPage() {
  return <UserTable />;
}
